module.exports = __webpack_public_path__ + "static/img/石头分子筛洗烘一体机Z1 Pro.64183e2d.png";